import $ from 'jquery';
/**
 *
 * @param element
 */
export function scrollToTopOfElement(element, offset = 0) {
  $('html, body').animate( { scrollTop: element.offset().top - offset, }, 1000 );
}

/**
 *
 * @param str // representing the string time i.e. "8:00"
 * @param period // representing the period of day i.e. "AM" or "PM"
 */

export function convertStrToMilitaryTime(str, period) {
  const strings = str.split(':');
  const hour = parseInt(strings[0]);
  const minutes = parseInt(strings[1]) / 60;
  return period == 'AM' ? hour + minutes : hour + 12 + minutes;
}

export function replaceUrlParam(url, paramName, paramValue) {
  if (paramValue == null) {
    paramValue = '';
  }
  var pattern = new RegExp('\\b(' + paramName + '=).*?(&|#|$)');
  if (url.search(pattern) >= 0) {
    return url.replace(pattern, '$1' + paramValue + '$2');
  }
  url = url.replace(/[?#]$/, '');
  return url + (url.indexOf('?') > 0 ? '&' : '?') + paramName + '=' + paramValue;
}

export function trimHTMLtoWordCount(HTML, wordcount) {
  // removes all html tags - converts to text
  HTML = HTML.replace(/<br\s\/>/g, ' @break ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  // trims out any words over the count
  HTML = HTML.split(' ')
    .slice(0, wordcount)
    .join(' ')
    .replace(/&amp;/g, '&')
    .replace(/&nbsp;/g, ' ')
    .replace(/@break/g, '<br>');

  return HTML;
}

export function trimHTMLtoCharCount(HTML, charcount) {
  // removes all html tags - converts to text
  HTML = HTML.replace(/<br\s\/>/g, ' @break ')
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();

  // trims out any words over the count
  HTML = HTML.substring(0, charcount);

  return HTML;
}

export function isOdd(num) {
  return num % 2;
}

export function capFirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function hasAttr(elem, name) {
  return elem.attr(name) !== undefined;
}